export default __webpack_public_path__ + "static/media/img0.95f7f9b0.png";